import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAlphanumericOnly]'
})
export class AlphanumericOnlyDirective {
  constructor(private ngControl: NgControl) { }

  @HostListener('input') onInputChange(): void {
    const initialValue = this.ngControl.value;
    const newValue = initialValue.replace(/[^a-zA-Z0-9\s]*/g, '');
    if (initialValue !== newValue) {
      this.ngControl.reset(newValue);
    }
  }
}
